var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner-blackout"},[_c('i',{staticClass:"icon sm rhg-font-icon--calendar"}),_c('span',{staticClass:"banner-blackout__text"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }